
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35537",
  depVersions: {
  "documents-public-ui": "static-1.35537",
  "atom": "static-1.5549",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2962",
  "client-types": "static-1.510",
  "cssUtils": "static-1.1099",
  "customer-data-filters-ui": "static-1.41363",
  "customer-data-objects": "static-1.8180",
  "customer-data-property-utils": "static-1.8527",
  "documents-lib": "static-1.35542",
  "emoji-mart": "static-3.7",
  "flux-actions": "static-1.380",
  "FormsCommonComponents": "static-1.86838",
  "FormUrlGenerator": "static-2.5189",
  "foundations-theming-specialty": "static-1.2680",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6069",
  "hs-test-utils": "static-1.8515",
  "hub-http": "static-1.6683",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12270",
  "HubStyleTokens": "static-2.11963",
  "I18n": "static-7.1708",
  "icons": "static-2.703",
  "jasmine-immutable": "static-1.3414",
  "jasmine-runner": "static-1.6928",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7623",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3361",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5856",
  "quartz": "static-1.7659",
  "react": "static-7.202",
  "react-dlb": "static-1.93",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17214",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5658",
  "react-virtualized": "static-2.112",
  "reference-resolvers": "static-1.8660",
  "reference-resolvers-lite": "static-1.8587",
  "reporting-data": "static-1.69350",
  "reporting-reports": "static-1.69026",
  "reporting-snowflake": "static-1.57966",
  "reporting-testing-lib": "static-1.11283",
  "reporting-visualizations": "static-1.61424",
  "reselect": "static-3.16",
  "sales-content-partitioning": "static-1.9437",
  "sanitize": "static-1.4951",
  "sanitize-text": "static-1.8634",
  "SharedI18nStrings": "static-1.187",
  "SharedLegalStrings": "static-1.2206",
  "signup-constants": "static-1.19945",
  "signup-ui-url-generator": "static-2.8520",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5236",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5225",
  "ui-addon-form-validation": "static-1.11348",
  "ui-asset-management-lib": "static-1.11577",
  "ui-images": "static-2.1277",
  "UIComponents": "static-3.8909",
  "usage-tracker": "static-1.7800",
  "usage-tracker-container": "static-1.7790",
  "usage-tracker-core": "static-1.7650",
  "viral-links-lib": "static-1.7558",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10116",
  "foundations-components": "static-1.8750",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1437",
  "quartz-core": "static-1.6878",
  "quick-fetch": "static-1.4233",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "rpc-client-utils": "static-1.5146",
  "ui-addon-i18n": "static-1.11622",
  "ui-addon-upgrades": "static-9.18547",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3936",
  "quartz-webpack": "static-1.3883",
  "foundations-assets": "static-1.5362",
  "foundations-theming": "static-1.4964",
  "hub-http-janus": "static-1.907",
  "hub-http-shared-msw-handlers": "static-1.10905",
  "hubspotter-http": "static-1.4977",
  "trellis-components": "static-1.3112",
  "trellis-migration-context": "static-1.56",
  "sassPrefix": "static-1.365",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44106",
  "customer-data-filters-ui-msw-helpers": "static-1.23798",
  "customer-data-objects-ui-components": "static-1.13512",
  "customer-data-reference-ui-components": "static-1.13651",
  "customer-data-ui-utilities": "static-1.10308",
  "events-data-lib": "static-1.721",
  "framework-builder-read-service-client": "static-1.4337",
  "hs-resources": "static-1.667",
  "immer": "static-1.105",
  "inbound-db-meta-service-client": "static-1.3776",
  "inbound-db-properties-service-client": "static-1.4153",
  "multi-account-reference-resolvers": "static-1.1485",
  "onboarding-tours": "static-1.17407",
  "pulse": "static-1.1123",
  "reporting-datasets-permissions-lib": "static-1.14772",
  "segments-client-types": "static-1.12149",
  "stylex": "static-1.46",
  "trellis-assets": "static-1.3093",
  "trellis-theming": "static-1.1481",
  "ui-addon-teams": "static-1.22013",
  "quartz-auth": "static-1.1334",
  "ui-business-units-lib": "static-1.9572",
  "usage-tracker-session-replay": "static-1.5486",
  "ai-components-ui-library": "static-1.10021",
  "ContentUtils": "static-1.69475",
  "customer-data-properties": "static-1.53052",
  "forms-ai-lib": "static-1.4986",
  "forms-utils-lib": "static-1.13339",
  "foundations-components-test-utils": "static-1.6233",
  "react-dnd-compat": "static-1.5086",
  "react-tinymce": "static-1.56273",
  "tinymce-config": "static-2.55399",
  "ui-gdpr-components": "static-1.10656",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3949",
  "HeadJS": "static-2.822",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3626",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.402",
  "ui-fonts": "static-1.1225",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4784",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.177",
  "quartz-head": "static-1.1324",
  "web-vitals": "static-1.19",
  "batch-promise": "static-1.2024",
  "external-options-client-types": "static-1.4441",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1334",
  "frontend-preferences-client": "static-1.8397",
  "graphql": "static-1.93",
  "persist-promise": "static-1.4181",
  "reporting-client-types": "static-1.2837",
  "apollo-stack-hubspot": "static-3.99",
  "hubspot-apollo-client": "static-1.5357",
  "foundations-components-legacy": "static-1.1775",
  "quartz-routing": "static-1.1089",
  "hs-story-utils": "static-1.9902",
  "react-flip-move": "static-1.83",
  "nested-table": "static-1.709",
  "seat-types-lib": "static-1.1055",
  "timezone-utils": "static-2.5706",
  "react-create-root-preference": "static-1.103",
  "bend-plugin-foundations-components": "static-1.5019",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "tanstack-table": "static-1.66",
  "opentelemetry-fe-types": "static-1.268",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.643",
  "quartz-test": "static-1.1334",
  "quartz-tracking": "static-1.1038",
  "bend-plugin-chirp-manifest": "static-1.556",
  "chirp-fetch": "static-1.2381",
  "merchandise-lib": "static-1.284",
  "purchase-motions-components": "static-1.6635",
  "ts-schema": "static-1.4395",
  "bender-build-tools": "static-1.3589",
  "bend-plugin-foundations-theming": "static-1.3447",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "restore-request-side-panel-lib": "static-1.2034",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5064",
  "conditional-properties-service-client": "static-1.4115",
  "crm-pipelines-api-client-types": "static-1.4445",
  "event-emitter": "static-1.1438",
  "fdsr-migration-layer": "static-1.487",
  "multi-currency-client-types": "static-1.4009",
  "getting-started-shared-tasks": "static-1.19565",
  "growth-data-modal": "static-1.6136",
  "growth-onboarding-confetti": "static-1.3535",
  "growth-onboarding-next-action-utils": "static-1.2986",
  "navigation-components": "static-1.19169",
  "nest": "static-1.711",
  "onboarding-tours-client": "static-1.5622",
  "onboarding-tours-utils": "static-1.1474",
  "ui-shepherd-react": "static-3.10755",
  "ui-shepherd-tracker": "static-1.8136",
  "ui-universal-auth": "static-1.9746",
  "user-context": "static-1.5530",
  "bend-plugin-pulse": "static-1.626",
  "fast-json-patch": "static-1.74",
  "crm-index-associations-lib": "static-1.6925",
  "stylex-utils": "static-1.175",
  "hubspotter-http-shared-msw-handlers": "static-1.10903",
  "magpie-lib": "static-1.5909",
  "navigation-messaging": "static-1.8496",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23890",
  "copilot-toolkit": "static-1.12151",
  "cms-field-types": "static-1.5287",
  "content-icons-ui": "static-1.2458",
  "integrations-lib": "static-1.17432",
  "calling-global-api": "static-1.66194",
  "calling-internal-common": "static-1.31802",
  "calling-lifecycle-internal": "static-1.67576",
  "calling-lifecycle-messages": "static-1.59869",
  "commerce-products-lib": "static-1.10921",
  "crm-index-visualization-core": "static-1.4758",
  "crm-links": "static-1.6785",
  "customer-data-properties-shared-msw-handlers": "static-1.10232",
  "file-manager-components": "static-1.24844",
  "formula-editor": "static-1.15014",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1108",
  "object-builder-ui-client": "static-1.50050",
  "pipeline-validation-client-types": "static-1.4283",
  "property-value-citations": "static-1.3666",
  "smart-data-capture-core": "static-1.475",
  "smart-property-lib": "static-1.8659",
  "tiered-pricing": "static-1.2280",
  "topics-actions-lib": "static-1.658",
  "trellis-ext-i18n": "static-1.1391",
  "trial-components-library": "static-1.14378",
  "ui-addon-iframeable": "static-1.9551",
  "zustand": "static-1.89",
  "final-form": "static-1.83",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.82",
  "rich-text-lib": "static-1.20557",
  "tinymce-themes": "static-1.57369",
  "data-token-picker": "static-1.17137",
  "hub-http-contrib": "static-1.3508",
  "interframe": "static-3.5217",
  "tinymce-data": "static-1.41484",
  "tinymce-plugins": "static-1.58513",
  "ui-addon-sales-email": "static-1.5678",
  "hubspot-apollo-cache": "static-1.816",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.627",
  "opentelemetry-web": "static-1.22",
  "onboarding-scopes": "static-1.6929",
  "purchase-motions-api": "static-1.6638",
  "onboarding-data-sync-lib": "static-1.2842",
  "growth-onboarding-next-action-components": "static-1.3014",
  "user-context-client": "static-1.4986",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5369",
  "reactive-lib": "static-1.1195",
  "simple-logging-lib": "static-1.3527",
  "custom-vendor-connection-lib": "static-1.310",
  "unified-auth-core-lib": "static-1.1542",
  "getting-started-shared-tasks-store": "static-1.18683",
  "nav-meta": "static-1.30806",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2187",
  "integrations-error-boundary-lib": "static-1.14847",
  "integrations-tracking-lib": "static-1.6096",
  "native-integrations-shared-strings": "static-1.8240",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10847",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31809",
  "shared-worker-versioning": "static-1.11517",
  "calling-usage-tracker": "static-1.7015",
  "customer-data-tracking": "static-1.7346",
  "voice-sms-access-library": "static-1.2445",
  "commerce-permissions": "static-1.1261",
  "growth-payments-core": "static-1.26503",
  "products-iframe-lib": "static-1.8909",
  "products-ui-components-shared-msw-handlers": "static-1.11287",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10988",
  "sales-views-client-types": "static-1.4733",
  "framework-data-schema-resolvers": "static-1.7368",
  "location-customization-utils-lib": "static-1.10421",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4618",
  "poll-commands": "static-1.3954",
  "video-components-external": "static-1.12433",
  "video-data-lib": "static-1.36091",
  "bark-lib": "static-1.17007",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6371",
  "react-codemirror": "static-1.11118",
  "data-agent-kit": "static-1.919",
  "data-agent-test-utils": "static-1.463",
  "data-agent-utils": "static-1.932",
  "feedback-loader": "static-1.30064",
  "fsm": "static-1.4234",
  "policy-lib": "static-1.7282",
  "react-colorpicker": "static-2.10686",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11051",
  "embedded-academy-lib": "static-1.16007",
  "hubs-service-types": "static-1.1744",
  "nudge-client-utils": "static-1.3422",
  "salesImages": "static-1.734",
  "FileManagerLib": "static-1.40484",
  "NamespacedHubStyle": "static-2.9369",
  "FileManagerCore": "static-1.40343",
  "content-assistance-lib": "static-1.8425",
  "layout-dnd-components": "static-1.13231",
  "layout-dnd-utils": "static-1.12206",
  "ui-addon-emoji-picker": "static-1.10340",
  "ui-brand-identity-lib": "static-1.16951",
  "InboxConnectUtils": "static-4.15845",
  "meetings-connect-utils-lib": "static-1.8095",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1165",
  "breeze-engine-core": "static-1.1465",
  "highlight.js": "static-1.90",
  "universal-page-editor-lib": "static-1.3487",
  "calling-orchestration-schema": "static-1.37222",
  "ui-addon-opt": "static-4.8883",
  "framework-data-schema-quick-fetch": "static-1.7273",
  "crm-record-cards-service-types": "static-1.3871",
  "content-media-composition-data-lib": "static-1.13595",
  "content-media-compositions": "static-2.17602",
  "media-bridge-lib": "static-1.19645",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16671",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4974",
  "enrichment-settings-lib": "static-1.236",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15468",
  "nudge-custom-function-registry": "static-1.3179",
  "nudge-renderer-utils": "static-1.3498",
  "whisper-core-api": "static-1.7638",
  "audio-components": "static-1.6573",
  "FileManagerImages": "static-1.37995",
  "video-components": "static-1.14435",
  "breeze-artifacts-sdk": "static-1.957",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4991",
  "video-embed": "static-1.36925",
  "ui-addon-video-player": "static-1.9100",
  "ui-coaching-tips": "static-1.29585",
  "ContentData": "static-1.69550",
  "layout-data-lib": "static-1.10531",
  "academy-service-client": "static-1.4168",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4873",
  "trellis-ecosystem": "static-1.7851",
  "ui-addon-react-router-dom": "static-1.10001",
  "wootric-nps": "static-1.7298",
  "social-insights-client-types": "static-1.22933",
  "outpost": "static-1.4604",
  "growth-onboarding-feedback-components": "static-1.7057",
  "advanced-menus-core": "static-1.15818",
  "advanced-menus-lib": "static-1.12571",
  "ExportDialog": "static-6.10851",
  "ui-memberships-settings-lib": "static-1.35197",
  "marketplace-ui-apps-core": "static-1.19582",
  "marketplace-ui-common": "static-1.21050",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15817",
  "simple-menus-lib": "static-1.17334",
  "settings-ui-lib": "static-1.13003",
  "developer-experience-shared-components": "static-1.11015",
  "immutable-less": "static-1.5129",
  "marketplace-ui-client-types": "static-1.18457",
  "ui-addon-integrations-directory-panel": "static-2.8429",
  "ui-extensibility-client-types": "static-1.4392",
  "ai-settings-ui-library": "static-1.8588",
  "ui-product-approvals-common": "static-1.1583",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4614",
  "simple-data-table": "static-1.3825"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35537",
  "atom": "/atom/static-1.5549",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2962",
  "client-types": "/client-types/static-1.510",
  "cssUtils": "/cssUtils/static-1.1099",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41363",
  "customer-data-objects": "/customer-data-objects/static-1.8180",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8527",
  "documents-lib": "/documents-lib/static-1.35542",
  "emoji-mart": "/emoji-mart/static-3.7",
  "flux-actions": "/flux-actions/static-1.380",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86838",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5189",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2680",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6069",
  "hs-test-utils": "/hs-test-utils/static-1.8515",
  "hub-http": "/hub-http/static-1.6683",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12270",
  "HubStyleTokens": "/HubStyleTokens/static-2.11963",
  "I18n": "/I18n/static-7.1708",
  "icons": "/icons/static-2.703",
  "jasmine-immutable": "/jasmine-immutable/static-1.3414",
  "jasmine-runner": "/jasmine-runner/static-1.6928",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7623",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3361",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5856",
  "quartz": "/quartz/static-1.7659",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17214",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5658",
  "react-virtualized": "/react-virtualized/static-2.112",
  "reference-resolvers": "/reference-resolvers/static-1.8660",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8587",
  "reporting-data": "/reporting-data/static-1.69350",
  "reporting-reports": "/reporting-reports/static-1.69026",
  "reporting-snowflake": "/reporting-snowflake/static-1.57966",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11283",
  "reporting-visualizations": "/reporting-visualizations/static-1.61424",
  "reselect": "/reselect/static-3.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9437",
  "sanitize": "/sanitize/static-1.4951",
  "sanitize-text": "/sanitize-text/static-1.8634",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2206",
  "signup-constants": "/signup-constants/static-1.19945",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5236",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5225",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11577",
  "ui-images": "/ui-images/static-2.1277",
  "UIComponents": "/UIComponents/static-3.8909",
  "usage-tracker": "/usage-tracker/static-1.7800",
  "usage-tracker-container": "/usage-tracker-container/static-1.7790",
  "usage-tracker-core": "/usage-tracker-core/static-1.7650",
  "viral-links-lib": "/viral-links-lib/static-1.7558",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10116",
  "foundations-components": "/foundations-components/static-1.8750",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1437",
  "quartz-core": "/quartz-core/static-1.6878",
  "quick-fetch": "/quick-fetch/static-1.4233",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.5146",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11622",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3936",
  "quartz-webpack": "/quartz-webpack/static-1.3883",
  "foundations-assets": "/foundations-assets/static-1.5362",
  "foundations-theming": "/foundations-theming/static-1.4964",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10905",
  "hubspotter-http": "/hubspotter-http/static-1.4977",
  "trellis-components": "/trellis-components/static-1.3112",
  "trellis-migration-context": "/trellis-migration-context/static-1.56",
  "sassPrefix": "/sassPrefix/static-1.365",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44106",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23798",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13512",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13651",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10308",
  "events-data-lib": "/events-data-lib/static-1.721",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4337",
  "hs-resources": "/hs-resources/static-1.667",
  "immer": "/immer/static-1.105",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3776",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4153",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1485",
  "onboarding-tours": "/onboarding-tours/static-1.17407",
  "pulse": "/pulse/static-1.1123",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14772",
  "segments-client-types": "/segments-client-types/static-1.12149",
  "stylex": "/stylex/static-1.46",
  "trellis-assets": "/trellis-assets/static-1.3093",
  "trellis-theming": "/trellis-theming/static-1.1481",
  "ui-addon-teams": "/ui-addon-teams/static-1.22013",
  "quartz-auth": "/quartz-auth/static-1.1334",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9572",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5486",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10021",
  "ContentUtils": "/ContentUtils/static-1.69475",
  "customer-data-properties": "/customer-data-properties/static-1.53052",
  "forms-ai-lib": "/forms-ai-lib/static-1.4986",
  "forms-utils-lib": "/forms-utils-lib/static-1.13339",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6233",
  "react-dnd-compat": "/react-dnd-compat/static-1.5086",
  "react-tinymce": "/react-tinymce/static-1.56273",
  "tinymce-config": "/tinymce-config/static-2.55399",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3949",
  "HeadJS": "/HeadJS/static-2.822",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3626",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.402",
  "ui-fonts": "/ui-fonts/static-1.1225",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4784",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.177",
  "quartz-head": "/quartz-head/static-1.1324",
  "web-vitals": "/web-vitals/static-1.19",
  "batch-promise": "/batch-promise/static-1.2024",
  "external-options-client-types": "/external-options-client-types/static-1.4441",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1334",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8397",
  "graphql": "/graphql/static-1.93",
  "persist-promise": "/persist-promise/static-1.4181",
  "reporting-client-types": "/reporting-client-types/static-1.2837",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5357",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1775",
  "quartz-routing": "/quartz-routing/static-1.1089",
  "hs-story-utils": "/hs-story-utils/static-1.9902",
  "react-flip-move": "/react-flip-move/static-1.83",
  "nested-table": "/nested-table/static-1.709",
  "seat-types-lib": "/seat-types-lib/static-1.1055",
  "timezone-utils": "/timezone-utils/static-2.5706",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5019",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "tanstack-table": "/tanstack-table/static-1.66",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.268",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.643",
  "quartz-test": "/quartz-test/static-1.1334",
  "quartz-tracking": "/quartz-tracking/static-1.1038",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.556",
  "chirp-fetch": "/chirp-fetch/static-1.2381",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "purchase-motions-components": "/purchase-motions-components/static-1.6635",
  "ts-schema": "/ts-schema/static-1.4395",
  "bender-build-tools": "/bender-build-tools/static-1.3589",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3447",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2034",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5064",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4115",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4445",
  "event-emitter": "/event-emitter/static-1.1438",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.487",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4009",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19565",
  "growth-data-modal": "/growth-data-modal/static-1.6136",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3535",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2986",
  "navigation-components": "/navigation-components/static-1.19169",
  "nest": "/nest/static-1.711",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5622",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1474",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10755",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8136",
  "ui-universal-auth": "/ui-universal-auth/static-1.9746",
  "user-context": "/user-context/static-1.5530",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.626",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6925",
  "stylex-utils": "/stylex-utils/static-1.175",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10903",
  "magpie-lib": "/magpie-lib/static-1.5909",
  "navigation-messaging": "/navigation-messaging/static-1.8496",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23890",
  "copilot-toolkit": "/copilot-toolkit/static-1.12151",
  "cms-field-types": "/cms-field-types/static-1.5287",
  "content-icons-ui": "/content-icons-ui/static-1.2458",
  "integrations-lib": "/integrations-lib/static-1.17432",
  "calling-global-api": "/calling-global-api/static-1.66194",
  "calling-internal-common": "/calling-internal-common/static-1.31802",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67576",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59869",
  "commerce-products-lib": "/commerce-products-lib/static-1.10921",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4758",
  "crm-links": "/crm-links/static-1.6785",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10232",
  "file-manager-components": "/file-manager-components/static-1.24844",
  "formula-editor": "/formula-editor/static-1.15014",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1108",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50050",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4283",
  "property-value-citations": "/property-value-citations/static-1.3666",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.475",
  "smart-property-lib": "/smart-property-lib/static-1.8659",
  "tiered-pricing": "/tiered-pricing/static-1.2280",
  "topics-actions-lib": "/topics-actions-lib/static-1.658",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1391",
  "trial-components-library": "/trial-components-library/static-1.14378",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9551",
  "zustand": "/zustand/static-1.89",
  "final-form": "/final-form/static-1.83",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "rich-text-lib": "/rich-text-lib/static-1.20557",
  "tinymce-themes": "/tinymce-themes/static-1.57369",
  "data-token-picker": "/data-token-picker/static-1.17137",
  "hub-http-contrib": "/hub-http-contrib/static-1.3508",
  "interframe": "/interframe/static-3.5217",
  "tinymce-data": "/tinymce-data/static-1.41484",
  "tinymce-plugins": "/tinymce-plugins/static-1.58513",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5678",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.816",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.627",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "onboarding-scopes": "/onboarding-scopes/static-1.6929",
  "purchase-motions-api": "/purchase-motions-api/static-1.6638",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2842",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3014",
  "user-context-client": "/user-context-client/static-1.4986",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5369",
  "reactive-lib": "/reactive-lib/static-1.1195",
  "simple-logging-lib": "/simple-logging-lib/static-1.3527",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.310",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1542",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18683",
  "nav-meta": "/nav-meta/static-1.30806",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2187",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14847",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6096",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8240",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10847",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31809",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11517",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7015",
  "customer-data-tracking": "/customer-data-tracking/static-1.7346",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2445",
  "commerce-permissions": "/commerce-permissions/static-1.1261",
  "growth-payments-core": "/growth-payments-core/static-1.26503",
  "products-iframe-lib": "/products-iframe-lib/static-1.8909",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11287",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10988",
  "sales-views-client-types": "/sales-views-client-types/static-1.4733",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7368",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10421",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4618",
  "poll-commands": "/poll-commands/static-1.3954",
  "video-components-external": "/video-components-external/static-1.12433",
  "video-data-lib": "/video-data-lib/static-1.36091",
  "bark-lib": "/bark-lib/static-1.17007",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6371",
  "react-codemirror": "/react-codemirror/static-1.11118",
  "data-agent-kit": "/data-agent-kit/static-1.919",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.463",
  "data-agent-utils": "/data-agent-utils/static-1.932",
  "feedback-loader": "/feedback-loader/static-1.30064",
  "fsm": "/fsm/static-1.4234",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-colorpicker": "/react-colorpicker/static-2.10686",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11051",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16007",
  "hubs-service-types": "/hubs-service-types/static-1.1744",
  "nudge-client-utils": "/nudge-client-utils/static-1.3422",
  "salesImages": "/salesImages/static-1.734",
  "FileManagerLib": "/FileManagerLib/static-1.40484",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9369",
  "FileManagerCore": "/FileManagerCore/static-1.40343",
  "content-assistance-lib": "/content-assistance-lib/static-1.8425",
  "layout-dnd-components": "/layout-dnd-components/static-1.13231",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12206",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10340",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16951",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15845",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8095",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1165",
  "breeze-engine-core": "/breeze-engine-core/static-1.1465",
  "highlight.js": "/highlight.js/static-1.90",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3487",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37222",
  "ui-addon-opt": "/ui-addon-opt/static-4.8883",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7273",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13595",
  "content-media-compositions": "/content-media-compositions/static-2.17602",
  "media-bridge-lib": "/media-bridge-lib/static-1.19645",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16671",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4974",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.236",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15468",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3179",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3498",
  "whisper-core-api": "/whisper-core-api/static-1.7638",
  "audio-components": "/audio-components/static-1.6573",
  "FileManagerImages": "/FileManagerImages/static-1.37995",
  "video-components": "/video-components/static-1.14435",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.957",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4991",
  "video-embed": "/video-embed/static-1.36925",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9100",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29585",
  "ContentData": "/ContentData/static-1.69550",
  "layout-data-lib": "/layout-data-lib/static-1.10531",
  "academy-service-client": "/academy-service-client/static-1.4168",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4873",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7851",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10001",
  "wootric-nps": "/wootric-nps/static-1.7298",
  "social-insights-client-types": "/social-insights-client-types/static-1.22933",
  "outpost": "/outpost/static-1.4604",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7057",
  "advanced-menus-core": "/advanced-menus-core/static-1.15818",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12571",
  "ExportDialog": "/ExportDialog/static-6.10851",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35197",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15817",
  "simple-menus-lib": "/simple-menus-lib/static-1.17334",
  "settings-ui-lib": "/settings-ui-lib/static-1.13003",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11015",
  "immutable-less": "/immutable-less/static-1.5129",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8429",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4392",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8588",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1583",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4614",
  "simple-data-table": "/simple-data-table/static-1.3825"
}
};
